import { render, staticRenderFns } from "./IconIntegrate.vue?vue&type=template&id=01cafc5b&"
import script from "./IconIntegrate.vue?vue&type=script&lang=js&"
export * from "./IconIntegrate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01cafc5b')) {
      api.createRecord('01cafc5b', component.options)
    } else {
      api.reload('01cafc5b', component.options)
    }
    module.hot.accept("./IconIntegrate.vue?vue&type=template&id=01cafc5b&", function () {
      api.rerender('01cafc5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconIntegrate.vue"
export default component.exports